<template>
  <div>
    <bpc-page-title :heading=heading :subheading=subheading :icon=icon></bpc-page-title>
  </div>
</template>

<script>
import BpcPageTitle from '@/mockups/layouts/components/BpcPageTitle.vue';

export default {
  components: {
    BpcPageTitle,
  },
  data: () => ({
    heading: 'Dashboard',
    subheading: 'This is your BPC dashboard',
    icon: 'pe-7s-plane icon-gradient bg-tempting-azure',
  }),
};
</script>
